import { autoserialize, autoserializeAs } from 'cerialize';
import { isNullOrUndefined, DateUtil } from '@uzurv/core';

// TODO: Refactor this with the correct spelling
export class LyftRendesvous {
  @autoserializeAs(Date)
  timeStamp: Date;

  @autoserialize
  latitude: number;

  @autoserialize
  longitude: number;

  @autoserialize
  addressDisplay: string;

  static OnSerialized(rendesvous: LyftRendesvous, json: any): void {
    if (!isNullOrUndefined(rendesvous.timeStamp)) {
      json.timeStamp = DateUtil.serializeDate(rendesvous.timeStamp);
    }
  }

  static OnDeserialized(instance: LyftRendesvous, json: any): void {
    if (!isNullOrUndefined(json['timeStamp'])) {
      instance.timeStamp = DateUtil.deserializeDate(json['timeStamp']);
    }
  }
}
